// NEED Import mixin sortedProducts

import enums from "@/enums";
import { conditionalDiscountLines, CONDITION_CODE_NA_DD } from "@/helpers/conditionalDiscounts";

const getDiscountDom = {
  data() {
    return {
      findDiscountDD: 0,
    }
  },
  methods: {
    getDiscountDom(range = null) {
      if (!range) {
        return this.findDiscountDD;
      }

      const findDiscountDD = (energy, customerType) => {
        // ER-2932: when the simulation exposes the conditional discounts, the direct debit
        // ristourne is the [NA-DD] entry and details.discountDD must be ignored to avoid
        // counting it twice.
        if (energy && Array.isArray(energy.discounts)) {
          const directDebit = conditionalDiscountLines(energy).find(line => line.code === CONDITION_CODE_NA_DD);

          return directDebit ? -directDebit[customerType] : 0;
        }

        return energy && energy.details && energy.details.discountDD && (typeof energy.details.discountDD[customerType] === 'number') ?
          -energy.details.discountDD[customerType] : 0;
      }
      const keyByCustomerType = this.isPro ? 'priceEuro' : 'priceEuroVAT';
      this.findDiscountDD = findDiscountDD(range[enums.energyEnum.ELECTRICITY], keyByCustomerType) + findDiscountDD(range[enums.energyEnum.GAS], keyByCustomerType);
    }
  }
}

export default getDiscountDom;



// WEBPACK FOOTER //
// ./src/mixins/getDiscountDom.js